<!--
     <SiteSelector />

     Public methods:
      - show()
      - hide()
-->

<template>
  <v-navigation-drawer
    v-model="drawer"
    fixed
    temporary
    :width="is_mobile ? 'auto' : '420px'"
    max-width="100%"
  >
    <div class="menu-selector-header" v-if="is_mobile">
      <v-icon medium @click="hide">mdi-close</v-icon>
    </div>
    <!-- style="width: 20%; ;" -->
    <div class="d-flex ss-filters">
      <SearchTextAdmin @input="setSearchText"></SearchTextAdmin>
      <v-autocomplete
      class="w-20"
        
        height="min-content"
        :value="selected_id"
        :items="show_sites_list.map(it => it.id).sort((a,b)=> {return a > b})"
        placeholder="Id"
        outlined
        flat
        clearable
        hide-details
        hide-selected
        solo
        dense
        @change="update_select"
      ></v-autocomplete>
    </div>
    <v-divider></v-divider>

    <div class="ss-cont" ref="sscont">
      <div
        v-for="site in filtered_sites_list"
        :key="site.id"
        class="ss-site"
      >
        <SiteMenuItem :site="site" v-if="isAdmin" />

        <div v-if="site_has_centros(site)">
          <div
            v-for="centro in iterate_site_centros(site)"
            :key="centro.id"
            @click="set_centro(centro)"
            class="ss-centro-cont"
            :data-key="centro.id"
          >
            <CentroMenuItem
              :centro="centro"
              :selected="centro.id == centro_id"
            />
          </div>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>


<style lang="scss">
 @import "@/sass/header.scss";

 .ss-cont {
   width: 100%;
   min-height: 64px;
   display: flex;
   flex-direction: column;
 }

 .ss-site {
   width: 100%;
 }

 .ss-filters {
  position: sticky;
  top: 0;
 }
</style>


<script>
 import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
 import SiteMenuItem from '@/components/header/SiteMenuItem'
 import CentroMenuItem from '@/components/header/CentroMenuItem'
 import customThemes from '@/plugins/themes.js'
 import SearchTextAdmin from '@/components/header/SearchTextAdmin'

 export default {
   name: "SiteSelector",

   components: {
     SiteMenuItem,
     SearchTextAdmin,
     CentroMenuItem,
   },

   props: {
     focus_active: {type: Boolean, default: true},
   },

   data: () => ({
     drawer: false,
     search: '',
     selected_id: null,
   }),

   computed: {
     ...mapGetters(['sitePath', 'site_data', 'centro_id', 'isAdmin']),
     ...mapState(['sites', 'sites_map', 'site_centros', 'centros', 'currentTheme', 'is_mobile']),

     qmkey_icon() {
       return (customThemes[this.currentTheme] || {}).logo || customThemes.logo;
     },

     site_id_pos() {
       // Returns the position of this.site_data.id in sites
       return this.sites.map(s => s.id).indexOf(this.site_data.id);
     },

     show_sites_list() {
       return this.sites.filter(v => v.name.toLowerCase().includes(this.search.toLowerCase()) || this.iterate_site_centros(v).length > 0)
     },

    filtered_sites_list() {
      if (this.selected_id) {
        return this.show_sites_list.filter(site => site.id == this.selected_id);
      } else {
        return this.show_sites_list;
      }
    },
   },

   methods: {
     // Public methods ////////////////
     show() {
       this.drawer = true;
       const elem = this.get_active_item_html_element();
       if (this.focus_active && elem)
         elem.scrollIntoView();
     },

     hide() {
       this.drawer = false;
     },
     //////////////////////////////////

     ...mapActions({
       REFRESH_STATE: 'REFRESH_STATE',
       set_user_site: 'UserSession/set_site',
       GOTO_CENTRO: 'GOTO_CENTRO',
     }),

     set_site(site_id) {
       const site_data = this.sites_map[site_id];
       this.failed_logo = false;
       this.set_user_site(site_data);
       this.REFRESH_STATE(this);
       this.$router.go();
     },

     async set_centro(centro) {
       if (centro.id == this.centro_id) {
         return;
       }
       await this.GOTO_CENTRO({centro_id: centro.id, context: this});
       this.$router.go();
     },

     needs_separator(site) {
       const depth = site.path.split('/').length - 2;
       return depth < 2;
     },

     get_active_item_html_element() {
       const cid = this.centro_id;
       return this.$refs.sscont.querySelector(`.ss-centro-cont[data-key="${cid}"]`);
     },

     setSearchText(input) {
       this.search = input;
     },

     centro_name_paths() {
       const res = {} // {centro_id: ["parent_name", "centro_name"]}
       for (const centro of Object.values(this.centros)) {
         res[centro.id] = '/' + centro.path.map(c => c.name).join('/');
       }
       return res;
     },

     site_has_centros(site) {
       // TODO: This could be improved
       return this.iterate_site_centros(site).length >= 0;
     },

     iterate_site_centros(site) {
       return (Array
         .from(this.site_centros[site.id] || [])
         .filter(v =>  site.name.toLowerCase().includes(this.search.toLowerCase()) 
          || v.name.toLowerCase().includes(this.search.toLowerCase()))
         .sort((a, b) => a.path_str.localeCompare(b.path_str))
       );
     },

     select_centro() {
       
     },

     update_select(selected) {
      this.selected_id = selected;
     },
   },

   watch: {
     drawer(open) {
       if (!open) {
         this.$emit('close');
       }
     },
   },
 }
</script>
